import { library } from '@fortawesome/fontawesome-svg-core';
import {

} from '@fortawesome/free-brands-svg-icons';

import { faEnvelope, faBuilding } from "@fortawesome/free-regular-svg-icons";
import { faHome ,faSearch} from "@fortawesome/free-solid-svg-icons";
import {
    faFilePdf,
    faTimesCircle,
    faCheckCircle,
    faCheckSquare, 
    faCircle,
    faSquare,
    faBars,
    faArrowDown,
    faTimes,
    faSlidersH,
    faCaretUp,
    faCaretDown,
    faExchangeAlt,
} from '@fortawesome/free-solid-svg-icons'


library.add(
    faEnvelope,
    faBuilding,
    faHome,
    faSearch,
    faFilePdf,
    faTimesCircle,
    faCheckCircle,
    faCheckSquare, 
    faCircle,
    faSquare,
    faBars,
    faArrowDown,
    faTimes,
    faSlidersH,
    faCaretUp,
    faCaretDown,
    faExchangeAlt,
);